export const ListingGallerySlotName = {
  AdditionalPhoto: 'additionalPhoto',
};
export const ListingGalleryActionTitle = {
  SeePhotos: 'See Photos',
  SeeVideo: ' See Video',
  Take3DTour: 'Take 3D Tour',
};
